var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.375 8.25a2.625 2.625 0 1 0-2.605-2.3L7.447 8.11a2.625 2.625 0 1 0 0 3.779l4.323 2.162q-.02.159-.02.324a2.625 2.625 0 1 0 .803-1.89l-4.323-2.16a2.7 2.7 0 0 0 0-.65l4.323-2.16a2.62 2.62 0 0 0 1.822.735"
  })));
};
export default SvgShare;